import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'ease-in', 'EaseIn', [["path",{"d":"M3 20c8 0 18 -16 18 -16"}]]);